import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayArrowIcon = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "none", viewBox: "0 0 32 32", ...props, children: _jsx("path", { fill: "currentColor", d: "M12.57 8.086A1 1 0 0 0 11 8.91v14.183a1 1 0 0 0 1.57.822l10.242-7.092a1 1 0 0 0 0-1.644z" }) }));
export default SvgPlayArrowIcon;
